import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter basename={"/cb-thirdpillar"}>
      <App />
    </BrowserRouter>
  </Provider>
);
